import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Button,
  TextField,
  Grid,
  IconButton,
  useTheme,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useSelector, useDispatch } from "react-redux";
import {
  addActiveRequests,
  updateLoading,
  updateLoadingMsg,
} from "../../../Redux/Reducers/uiSlice";
import { uploadToS3 } from "../../../utils/s3Utils";
import { sendWebSocketMessage } from "../../../hooks/useWebSocket";
import { getPayloadSize, payloadQualifiesForS3Upload } from "../../../component/Methods/checks";
import { toast } from "react-toastify";

const BulkDelete = (props) => {
  const theme = useTheme();
  const dispatch = useDispatch();

  const {
    bulkdelete,
    setBulkdelete,
    selectionModel,
    isBulkArchive,
    setIsBulkArchive,
  } = props;
  const user = useSelector((state) => state?.users?.user?.username);
  const { userInfo, apiInfo } = useSelector((state) => state?.users);

  const sendData = async (action, data, loadingMessage) => {
    const webSocketPayload = {
      action,
      data,
    };

    if (payloadQualifiesForS3Upload(getPayloadSize(webSocketPayload))) {
      try {
        const s3Result = await uploadToS3(
          webSocketPayload,
          apiInfo,
          userInfo,
          action
        );

        if (s3Result.success) {
          const s3ReferencePayload = {
            action,
            file: s3Result.fileName,
          };
          sendWebSocketMessage(JSON.stringify(s3ReferencePayload));
        } else {
          toast.error(
            `Failed to upload ${action} data to S3. Please try again later.`
          );
          return false;
        }
      } catch (error) {
        toast.error(
          `Failed to upload ${action} data to S3. Please try again later.`
        );
        return false;
      }
    } else {
      // Regular WebSocket for small payloads
      const payloadString = JSON.stringify(webSocketPayload);
      sendWebSocketMessage(payloadString);
    }

    dispatch(addActiveRequests(action));
    dispatch(updateLoading(true));
    dispatch(updateLoadingMsg(loadingMessage));
    return true;
  };

  const deleteItems = async () => {
    const tradeIds = selectionModel?.map((item) => item?.tradeId);

    if (tradeIds.length > 0) {
      const deleteData = {
        trades: tradeIds,
        user: user,
      };

      let loadingMessage = "";
      let action = "";

      if (isBulkArchive) {
        loadingMessage =
          tradeIds.length > 1 ? "Archiving Trades" : "Archiving Trade";
        action = "archive_trades";
      } else {
        loadingMessage =
          tradeIds.length > 1 ? "Deleting Trades" : "Deleting Trade";
        action = "delete_trades";
      }

      if (tradeIds.length > 1) {
        try {
          const webSocketPayload = {
            action: action,
            data: deleteData,
          };

          const s3Result = await uploadToS3(
            webSocketPayload,
            apiInfo,
            userInfo,
            action
          );

          if (s3Result.success) {
            const s3ReferencePayload = {
              action: action,
              file: s3Result.fileName,
            };
            sendWebSocketMessage(JSON.stringify(s3ReferencePayload));
          } else {
            toast.error(
              "Failed to upload delete data to S3. Please try again later."
            );
            return;
          }
        } catch (error) {
          toast.error(
            "Failed to upload delete data to S3. Please try again later."
          );
          return;
        }
      } else {
        // Regular WebSocket for single trade
        const payloadString = JSON.stringify({
          action: action,
          data: deleteData,
        });
        sendWebSocketMessage(payloadString);
      }

      dispatch(addActiveRequests(action));
      dispatch(updateLoading(true));
      dispatch(updateLoadingMsg(loadingMessage));
      setBulkdelete(false);
    } else {
      setBulkdelete(false);
    }
  };

  const handleClose = () => {
    setBulkdelete(false);
  };

  return (
    <Dialog
      open={bulkdelete}
      onClose={handleClose}
      sx={{ width: "100%", height: "100%" }}
    >
      <DialogContent dividers>
        <Typography
          variant="h6"
          component="div"
          align="center"
          style={{
            flexGrow: 1,
            fontSize: "20px",
            fontWeight: "bold",
            textTransform: "uppercase",
          }}
        >
          {isBulkArchive ? "Bulk Archive" : "Bulk Delete"}
        </Typography>
        <Typography
          variant="body"
          component="div"
          style={{ flexGrow: 1, fontSize: "13px", textAlign: "center" }}
        >
          {`Are you sure you want to ${
            isBulkArchive ? "archive" : "delete"
          } selected trades?`}
        </Typography>
        <Grid container>
          <Grid
            size={{ xs: 12 }}
            margin="20px 1px 20px 1px "
          display="flex"
          gap="10px"
          justifyContent="center"
        >
          <Button
            variant="contained"
            size="small"
            sx={{
              width: "40%",
              background: "#B2BEB5",
              color: "#000",
              "&:hover": { background: "#808080" },
            }}
            onClick={() => {
              setBulkdelete(false);
            }}
          >
            CANCEL
          </Button>

          <Button
            variant="contained"
            size="small"
            sx={{
              width: "40%",
              background: theme.palette.red[200],
              "&:hover": { background: theme.palette.red[300] },
            }}
            onClick={() => {
              deleteItems();
            }}
          >
            {isBulkArchive ? "ARCHIVE" : "DELETE"}
          </Button>
          </Grid>
        </Grid>
      </DialogContent>{" "}
    </Dialog>
  );
};

export default BulkDelete;
